module.exports = __webpack_public_path__ + "img/PP-Coin-Banner.f103a17c.png";